import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock, MapPin, Users, Calendar, Trophy } from "lucide-react";

export default function LandingPageContent() {
  const schedules = [
    { day: "Tirsdag / Tuesday", time: "21:00 - 22:30", courts: "3", location: "Padelon Lade" },
    { day: "Torsdag / Thursday", time: "18:00 - 19:30", courts: "2", location: "Padelon Lade" },
    { day: "Fredag / Friday (tidlig)", time: "15:00 - 16:30", courts: "1", location: "Padelon Lade" },
    { day: "Fredag / Friday (sen)", time: "16:30 - 18:00", courts: "3", location: "Padelon Lade" },
    { day: "Lørdag / Saturday", time: "16:00 - 18:00", courts: "6", location: "Hit Padel Rosten" },
    { day: "Søndag / Sunday (tidlig)", time: "13:30 - 15:00", courts: "1", location: "Padelon Lade" },
    { day: "Søndag / Sunday (sen)", time: "15:00 - 16:30", courts: "3", location: "Padelon Lade" },
  ];

  const levels = [
    { name: "Nybegynner / Beginner", description: "For nye spillere som lærer grunnleggende teknikk / For new players learning basic techniques" },
    { name: "Medium", description: "Spillere med noe erfaring / Players with some experience" },
    { name: "Medium+", description: "Erfarne spillere med god teknikk / Experienced players with good technique" },
    { name: "Viderekommende / Advanced", description: "A/B klasse turneringsnivå / A/B class tournament level" },
    { name: "Dame / Women", description: "Dame prioriterte økter - 24t tidlig påmelding / Women's priority sessions - 24h early registration" },
  ];

  return (
    <>
      {/* Schedule Section */}
      <section className="text-center">
        <h2 className="text-3xl font-bold mb-2">Faste treningsøkter / Regular Training Sessions</h2>
        <p className="text-muted-foreground mb-4">Drop-in trening - meld deg på 72 timer i forveien / Drop-in training - register 72 hours in advance</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 max-w-7xl mx-auto">
          {schedules.map((schedule, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-green-600 text-sm">
                  <Calendar className="h-4 w-4" />
                  {schedule.day}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2">
                <div className="flex items-center gap-2 text-sm font-semibold">
                  <Clock className="h-3 w-3" />
                  {schedule.time}
                </div>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Users className="h-3 w-3" />
                  {schedule.courts} baner / courts
                </div>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <MapPin className="h-3 w-3" />
                  {schedule.location}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* Playing Levels */}
      <section>
        <h2 className="text-3xl font-bold text-center mb-8">Padel nivåer / Padel Levels</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {levels.map((level, index) => (
            <Card key={index} className="text-center hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="text-blue-600 text-lg">{level.name}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">{level.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* Equipment & Location */}
      <section className="grid md:grid-cols-2 gap-8">
        <Card className="hover:shadow-lg transition-shadow">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Trophy className="h-6 w-6 text-green-600" />
              Utstyr inkludert / Equipment Included
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <p>• 7 racketer tilgjengelig i skap / 7 rackets available in locker</p>
            <p>• Baller inkludert for alle økter / Balls included for all sessions</p>
            <p>• Skap-kode gis når du melder deg på / Locker code provided when you register</p>
            <p>• Bare ta med deg selv og sportsklær! / Just bring yourself and sports clothes!</p>
          </CardContent>
        </Card>

        <Card className="hover:shadow-lg transition-shadow">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <MapPin className="h-6 w-6 text-blue-600" />
              Lokasjon / Location
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <div>
              <p className="font-semibold">Padelon Trondheim, Lade</p>
              <p className="text-sm text-muted-foreground">Bruk inngang ved Maske Marked / Use entrance at Maske Marked</p>
            </div>
            <div>
              <p className="font-semibold">Hit Padel Rosten</p>
              <p className="text-sm text-muted-foreground">Lørdager / Saturdays</p>
            </div>
            <p className="text-sm">Dørkode gis når du melder deg på / Door code provided when you register</p>
            <div className="bg-yellow-50 border border-yellow-200 rounded p-3">
              <p className="text-yellow-800 font-medium text-sm">
                Padelon rabatt tilgjengelig for studentmedlemmer! / Padelon discount available for student members!
              </p>
              <p className="text-yellow-700 text-xs">
                33% rabatt på hverdager før kl 16. Send studentbevis til Trondheim@Padelon.no / 
                33% discount on weekdays before 4 PM. Send student ID to Trondheim@Padelon.no
              </p>
            </div>
          </CardContent>
        </Card>
      </section>
    </>
  );
}